import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';
import {Button, Col, Row} from "react-bootstrap";
import FormInput from "../../forms/FormInput";
import DateTimePicker from "../../forms/DateTimePicker";
import moment from "moment";
import {connect} from "react-redux";
import {getTimezoneFromState} from "../../../helpers/intl";
import Loader from "../Loader";
import FormLangRichEditor from "../../forms/FormLangRichEditor";
import {addUpdateNotificationR} from "actions/ListActions";

class UpdateNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newDateTimeFrom: moment(Date.now()),
      newDateTimeTo: moment(Date.now()),
      newUpdateName: "",
      newUpdateDescription: "",
    };
  }

  setNewDateTime = (name, value) => {
    this.setState({ newDateTimeFrom: value });
  }

  setNewDateTimeTo = (name, value) => {
    this.setState({ newDateTimeTo: value });
  }

  changeNewUpdateName = (value) => {
    this.setState({ newUpdateName: value });
  }

  changeNewUpdateDescription = (name, value) => {
    this.setState({ newUpdateDescription: value });
  }



  createUpdateNotification = () => {
    const { newDateTimeFrom, newDateTimeTo, newUpdateName, newUpdateDescription } = this.state;
    this.props.addUpdateNotificationR({name: newUpdateName, description: newUpdateDescription,  dateFrom: newDateTimeFrom, dateTo: newDateTimeTo})
    this.props.close();
  }


  render() {
    const { intl, show, close, appIntl, defaultTimezone } = this.props;
    const { newDateTimeFrom, newDateTimeTo, newUpdateName, newUpdateDescription } = this.state;
    const messages = intl.messages;
    let createDisabled = true;
    if(newUpdateName !== null && newDateTimeFrom !== null && newDateTimeTo !== null && newUpdateDescription !== null){
      createDisabled = false;
    }

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.new_update_notification}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div>
                <h4></h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm" >

                <FormInput
                  type="text"
                  label={messages.update_name}
                  name="name"
                  onChange={(name, value) => {this.changeNewUpdateName(value)}}
                  value={newUpdateName}
                />
                <FormLangRichEditor
                  name="description"
                  label={messages.update_notification_description}
                  value={this.state.description}
                  onChange={(name, value) => {this.changeNewUpdateDescription(name, value)}}
                />
                <DateTimePicker
                  value={newDateTimeFrom}
                  label={messages.update_from}
                  locale={appIntl.locale}
                  displayTz={defaultTimezone}
                  onChange={this.setNewDateTime}
                />
                <DateTimePicker
                  value={newDateTimeTo}
                  label={messages.update_to}
                  locale={appIntl.locale}
                  displayTz={defaultTimezone}
                  onChange={this.setNewDateTimeTo}
                />
                {this.props.pending ?  <Loader/>:<></>}
                <Button onClick={()=>this.createUpdateNotification()}  disabled={createDisabled} bsStyle="primary"  className="pull-right" title="create_subscription">
                  <span className="hidden-xs">{messages.new_update_notification}</span>
                </Button>
              </div>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>
    );
  }
}


const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    pending: state.list.updates.pendingUp,
    list: state.list.updates,
    defaultTimezone: getTimezoneFromState(state),

  };
};

const mapDispatchToProps = dispatch => {
  return {
    addUpdateNotificationR: (data) => {
      dispatch(addUpdateNotificationR(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UpdateNew)
  )
);

